define('modules/overview/player_preview_option_model',[
  'backbone',
  'jquery',
  '_',
  'session'
], function (Backbone, $, _, session) {
  'use strict';

  var PlayerPreviewOptionModel = Backbone.Model.extend({
    playerId: 0,
    playerName: '',
    zoneName: ''
  });

  return PlayerPreviewOptionModel;
});

